import { PriceActionFilterKey, PriceActionFilters } from '@/types/common.types';

const getFilterLabel = (key: string): string => {
  const labels: { [key: string]: string } = {
    regional_office: 'Регіональне відділення',
    province: 'Область',
    brand: 'Бренд'
  };
  return labels[key] || key;
};

export const getActiveFilters = (filters: PriceActionFilters) => {
  const keyOrder: PriceActionFilterKey[] = ['regional_office', 'province', 'brand'];

  return keyOrder.flatMap(key => {
    const val = filters[key];
    const values: string[] = Array.isArray(val)
      ? val.filter((v): v is string => v !== undefined && v !== null && v !== '')
      : val
        ? [val]
        : [];

    return values.map(v => ({
      key: key as PriceActionFilterKey,
      label: getFilterLabel(key),
      value: v
    }));
  });
};

export const updateMultiSelect = (
  key: 'province' | 'brand',
  value: string,
  prevValues: string[],
  prov: string[],
  br: string[]
): string[] => {
  if (value === 'Всі') {
    const options = key === 'province' ? prov.filter(p => p !== 'Всі') : br.filter(b => b !== 'Всі');
    return options;
  }

  return prevValues.includes(value) ? prevValues : [...prevValues, value];
};

export const getUpdatedFilters = (
  filters: PriceActionFilters,
  filterKey: PriceActionFilterKey,
  value: string,
  provincesOptions: string[],
  brandsOptions: string[]
): PriceActionFilters => {
  let newFilters = { ...filters };

  if (filterKey === 'regional_office') {
    const rest = { ...newFilters };
    delete rest.province;
    delete rest.brand;
    newFilters = {
      ...rest,
      regional_office: [value]
    };
  } else {
    const prevValues: string[] = Array.isArray(newFilters[filterKey]) ? newFilters[filterKey] : [];
    newFilters[filterKey] = updateMultiSelect(filterKey, value, prevValues, provincesOptions, brandsOptions);
  }

  return newFilters;
};

export const getFiltersAfterRemove = (
  filters: PriceActionFilters,
  key: PriceActionFilterKey,
  value?: string
): PriceActionFilters => {
  let newFilters = { ...filters };

  if (value) {
    const currentValues: string[] = Array.isArray(newFilters[key])
      ? newFilters[key]
      : [newFilters[key]].filter((v): v is string => Boolean(v));

    const newValues = currentValues.filter(v => v !== value);

    if (newValues.length === 0) {
      delete newFilters[key];
    } else {
      newFilters[key] = newValues;
    }
  } else {
    delete newFilters[key];
  }

  if (key === 'regional_office') {
    const rest = { ...newFilters };
    delete rest.province;
    delete rest.brand;
    newFilters = rest;
  }

  return newFilters;
};
